import { scrollToEvent } from './helpers.js';

const setLiEvents = (lis, form) => {
  lis.forEach((candidateSelect) => {
    candidateSelect.addEventListener('click', function () {

      if (form.querySelector('.voting-form__candidate-list li.candidate--selected')) {        
        form
          .querySelector('.voting-form__candidate-list li.candidate--selected')
          .classList.remove('candidate--selected');
      }
      if (
        form
          .querySelector('.voting-form__candidate-list')
          .classList.contains('voting-form__candidate-list--error')
      ) {
        form
          .querySelector('.voting-form__candidate-list')
          .classList.remove('voting-form__candidate-list--error');
      }
      this.classList.add('candidate--selected');
      form.querySelector('.button-onelogin')?.setAttribute('href', this.getAttribute('data-url'));
      scrollToEvent(form.querySelector('.btn--main').getBoundingClientRect().top + window.scrollY);
    });
  });
};

const fetchCandidates = async (url, container) => {

  const form = document.getElementById('voting-form');
  try {
    console.log('try:', url);
    const response = await fetch(url);
    if (!response.ok) {
      console.log('notok', url);
      throw new Error(`Server responded with status: ${response.status}`);
    }
    console.log('ok', url);
    // eslint-disable-next-line no-param-reassign
    container.innerHTML = await response.text();
    setLiEvents(container.querySelectorAll('li'), form);
    form.querySelector('.voting-form__label')?.classList.remove('element-hidden');
    form.querySelector('.category-form__buttons')?.classList.remove('element-hidden');
  } catch (err) {
    console.log('Error', err);
    form.querySelector('.voting-form__fieldset--candidate').innerHTML = `<div class="category-form__message">
                  <h4>Lista kandydatów chwilowo niedostępna</h4>
                  <p>Proszę spróbować później...</p>
                </div>`;
    form.querySelector('.voting-form__label')?.classList.add('element-hidden');
    form.querySelector('.category-form__buttons')?.classList.add('element-hidden');
  }
};

export const formEmbed = () => {
  const form = document.getElementById('voting-form');
  if (!form) return;

  const categoryContainer = form.querySelector('.voting-form__fieldset--category');
  const input = categoryContainer.querySelector('.voting-form__input');
  const selectMenu = categoryContainer.querySelector('.voting-form__category-list');
  const selectField = categoryContainer.querySelector('.voting-form__category-display');

  categoryContainer.addEventListener('click', () => {
    selectMenu.classList.toggle('voting-form__category-list--visible');
    categoryContainer.classList.toggle('fieldset--active');
    selectMenu.addEventListener('mouseleave', () => {
      selectMenu.classList.remove('voting-form__category-list--visible');
      selectMenu.closest('fieldset').classList.remove('fieldset--active');
    });
  });

  selectMenu.addEventListener('click', e => {
    const c = e.target;
    if (c.nodeName!=='LI') return;
    const clickedTextFull = c.innerText;
    const clickedValue = c.getAttribute('data-category');
    selectField.innerText = clickedTextFull;
    input.value = clickedValue;
    fetchCandidates(        
      c.getAttribute('data-url'),
      form.querySelector('.voting-form__candidate-list'),
    );
  });

  setLiEvents(form.querySelectorAll('.voting-form__candidate-list li'), form);

  let data = {};

  form.querySelector('.button-onelogin').addEventListener('click', (e) => {
    if (form.querySelector('.voting-form__candidate-list li.candidate--selected')) {
      data.candidate = form
        .querySelector('.candidate--selected')
        .getAttribute('data-candidate');
    } else {
      form
        .querySelector('.voting-form__candidate-list')
        .classList.add('voting-form__candidate-list--error');
    }
    data.category = form.querySelector(
      '.voting-form__input[data-id="category"]',
    ).value;
    if (!data.category || !data.candidate) {
      e.preventDefault();
    }
  });

  form.querySelector('button.btn--main').addEventListener('click', async (e) => {
    e.preventDefault();
    data.category = form.querySelector(
      '.voting-form__input[data-id="category"]',
    ).value;
    data.button = 'vote';
    data.form_placement = form.getAttribute('data-placement') || 'embed';
    if (form.querySelector('.voting-form__candidate-list li.candidate--selected')) {
      data.candidate = form
        .querySelector('.candidate--selected')
        .getAttribute('data-candidate');
    } else {
      form
        .querySelector('.voting-form__candidate-list')
        .classList.add('voting-form__candidate-list--error');
    }

    if (data.category && data.candidate) {
      const url = form.getAttribute('data-url');

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });

        form.querySelector('.voting-form__label')?.classList.add('element-hidden');
        form.querySelector('.category-form__buttons')?.classList.add('element-hidden');

        data = {};

        if (!response.ok) {
          throw new Error(`Server responded with status: ${response.status}`);
        }

        form.querySelector('.voting-form__candidate-list').innerHTML = await response.text();
      } catch (err) {
        console.log('Error', err);
        form.reset();
        form.querySelector('.voting-form__candidate-list').innerHTML = `<div class="category-form__message">
                  <h4>Wystąpił błąd</h4>
                  <p>Proszę spróbować później...</p>
                </div>`;
        form.querySelector('.voting-form__label')?.classList.add('element-hidden');
        form.querySelector('.category-form__buttons')?.classList.add('element-hidden');
      }
    }
  });
};
